import axios from 'axios'


function assignDevice(trigger,device){
    return axios.post(`${process.env.VUE_APP_APIURL}/trigger/${trigger}/device`,{macAddress:device})
}
function removeDevice(trigger,device){
    return axios.delete(`${process.env.VUE_APP_APIURL}/trigger/${trigger}/device/${device}`)
}

function getTriggers() {
    return axios.get(`${process.env.VUE_APP_APIURL}/trigger`)
        .then(resp => {
            return resp.data.triggers.map(x=>{return{
                ...x,
                status:{}
            }})
        })
}

function updateConfig(id,config){
    return axios.put(`${process.env.VUE_APP_APIURL}/trigger/${id}/config`,config)
    .then(resp => {
        return resp.data
    })
}
export default {
    getTriggers,
    updateConfig,
    assignDevice,
    removeDevice
};